
export const TERMS_OF_SERVICE = `
이용약관
제 1 조 (목적)
본 이용약관은 매드웍스(이하 "회사")가 제공하는 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원(이하 "사용자") 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제 2 조 (정의)
서비스: 회사가 운영하는 웹사이트 및 모바일 애플리케이션을 통해 제공하는 모든 콘텐츠 및 기능을 의미합니다.
회원: 본 약관에 따라 서비스에 가입하고 회사가 제공하는 서비스를 이용하는 자를 의미합니다.
계정(ID): 회원 식별 및 서비스 이용을 위해 회원이 설정한 이메일 주소 또는 사용자명이 포함된 고유 식별자를 의미합니다.
비밀번호: 회원의 개인정보 보호 및 보안을 위해 회원이 설정한 문자와 숫자의 조합을 의미합니다.

제 3 조 (약관의 효력 및 변경)
본 약관은 회원이 회원가입 시 동의함으로써 효력이 발생합니다.
회사는 관련 법령을 준수하는 범위에서 본 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지사항 또는 이메일을 통해 사전 공지됩니다.
변경된 약관에 동의하지 않는 경우, 회원은 서비스 이용을 중단하고 탈퇴할 수 있습니다.

제 4 조 (회원가입 및 계정관리)
서비스 이용을 위해 회원가입이 필요하며, 회원은 본인의 정확한 정보를 제공해야 합니다.
회원이 제공한 정보가 허위로 판명될 경우, 회사는 회원의 서비스 이용을 제한할 수 있습니다.
회원은 자신의 계정 정보를 제3자에게 공유하거나 양도할 수 없습니다.
회원은 비밀번호 및 계정 정보를 안전하게 관리할 책임이 있으며, 계정 도용 및 부정 사용에 대한 책임은 회원에게 있습니다.

제 5 조 (개인정보 보호)
회사는 관련 법령에 따라 회원의 개인정보를 보호하며, 개인정보 처리방침을 따릅니다.
회사는 회원의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.
회원은 자신의 개인정보를 보호할 의무가 있으며, 이에 대한 위반으로 발생한 문제는 회사가 책임지지 않습니다.

제 6 조 (서비스 이용 및 제한)
회사는 회원에게 원활한 서비스를 제공하기 위해 노력하며, 서비스 운영에 필요한 경우 점검을 실시할 수 있습니다.
회원은 다음 행위를 금지합니다.
불법적인 목적의 서비스 이용
타인의 계정 도용 및 부정 사용
악성 코드 및 유해 프로그램 배포
회사 및 타인의 명예 훼손 또는 서비스 방해 행위
위반 행위 발생 시, 회사는 회원의 서비스 이용을 제한하거나 계정을 삭제할 수 있습니다.

제 7 조 (계약 해지 및 회원 탈퇴)
회원은 언제든지 서비스 내 탈퇴 기능을 이용하여 회원 탈퇴를 신청할 수 있습니다.
회원이 약관을 위반하는 경우, 회사는 사전 통지 없이 계정을 정지하거나 삭제할 수 있습니다.
계정이 삭제될 경우, 회원의 데이터는 복구되지 않습니다.

제 8 조 (책임의 한계 및 면책)
회사는 천재지변, 시스템 장애, 불가항력적 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.
회원이 서비스 이용 중 발생한 손해에 대해, 회사는 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.
회원 간의 분쟁 및 문제 발생 시, 회사는 개입할 의무가 없으며, 당사자 간 해결을 원칙으로 합니다.

제 9 조 (준거법 및 관할법원)
본 약관과 관련된 모든 분쟁은 대한민국 법률을 준거법으로 합니다.
본 약관과 관련하여 발생하는 분쟁의 관할법원은 회사의 본사 소재지 관할 법원으로 합니다.
`;

export const PRIVACY_POLICY = `
개인정보 처리방침
매드웍스(이하 "회사")는 이용자의 개인정보를 중요하게 생각하며, 『개인정보 보호법』 등 관련 법령을 준수하고 있습니다. 
본 개인정보 처리방침은 이용자가 서비스를 이용할 때 제공하는 개인정보가 어떻게 수집, 이용, 보호되는지를 안내하기 위해 마련되었습니다.

제 1 조 (수집하는 개인정보 항목 및 수집 방법)
회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집할 수 있습니다.

1. 수집하는 개인정보 항목
(1) 회원가입 시

필수정보: 이름, 이메일 주소, 비밀번호
선택정보: 프로필 사진, 전화번호
(2) 서비스 이용 과정에서 자동으로 수집되는 정보

접속 로그(IP 주소, 쿠키, 서비스 이용 기록)
기기 정보(브라우저 종류, 운영체제, 접속 기기)

2. 개인정보 수집 방법
회원가입 및 서비스 이용 과정에서 이용자가 직접 입력
자동 수집(쿠키, 로그 분석 도구 등)

제 2 조 (개인정보의 이용 목적)
회사는 수집한 개인정보를 다음과 같은 목적으로 이용합니다.

회원 관리 및 본인 확인
회원 가입 및 탈퇴 처리
계정 보호 및 부정 이용 방지
서비스 제공 및 운영
맞춤형 콘텐츠 제공
고객 문의 응대 및 공지사항 전달
서비스 개선 및 분석
서비스 이용 통계 분석
신규 서비스 개발 및 마케팅 활용
법적 의무 준수

관계 법령에 따른 보관 의무 준수

제 3 조 (개인정보의 보유 및 이용 기간)
회원이 서비스 이용을 계속하는 동안 회사는 개인정보를 보유 및 이용할 수 있습니다.
회원이 탈퇴하거나 개인정보 삭제를 요청하는 경우, 회사는 즉시 해당 정보를 삭제합니다.
관련 법령에 따라 일정 기간 보관해야 하는 정보는 다음과 같습니다.
계약 또는 청약철회 기록: 5년(전자상거래법)
대금 결제 및 공급 기록: 5년(전자상거래법)
소비자 불만 및 분쟁 처리 기록: 3년(전자상거래법)

제 4 조 (개인정보의 제공 및 위탁)
회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다.
다만, 법령에 따라 요청이 있는 경우, 수사기관 등 정부 기관에 제공될 수 있습니다.
원활한 서비스 운영을 위해 다음과 같이 개인정보 처리를 외부 업체에 위탁할 수 있습니다.

수탁업체	위탁업무 내용	보유 및 이용기간
AWS (Amazon Web Services)	데이터 보관 및 서버 운영	회원 탈퇴 또는 위탁 계약 종료 시까지
Google Analytics	서비스 이용 분석	회원 탈퇴 또는 위탁 계약 종료 시까지

제 5 조 (이용자의 권리 및 행사 방법)
이용자는 언제든지 자신의 개인정보를 조회, 수정, 삭제할 수 있습니다.
개인정보 열람, 정정, 삭제 요청은 madworks@mad-pipe.com을 통해 가능합니다.
이용자가 개인정보 삭제를 요청하는 경우, 회사는 관련 법령에 따라 즉시 조치합니다.

제 6 조 (개인정보 보호 대책)
회사는 개인정보 보호를 위해 다음과 같은 보안 조치를 적용합니다.

기술적 조치
SSL(Secure Socket Layer) 적용
암호화된 비밀번호 저장 및 전송

관리적 조치
개인정보 접근 권한 최소화
정기적인 보안 교육 및 점검

물리적 조치
개인정보 저장 서버 접근 제한
보안 시설 운영

제 7 조 (개인정보 보호 책임자 및 문의처)
회사는 개인정보 보호를 위한 책임자를 지정하고 있으며, 이용자의 문의를 신속하게 처리합니다.

개인정보 보호 책임자: 이병호
이메일: madworks@mad-pipe.com
전화번호: 070-8095-5732

제 8 조 (쿠키의 사용 및 거부 방법)
회사는 맞춤형 서비스 제공을 위해 쿠키를 사용할 수 있습니다.

쿠키란?
이용자의 기기에 저장되는 작은 데이터 파일로, 웹사이트 방문 정보를 기억합니다.

쿠키 사용 목적
로그인 유지, 맞춤형 광고 제공, 접속 기록 분석

쿠키 차단 방법
브라우저 설정에서 쿠키 저장을 거부할 수 있습니다.

설정 방법: (예시) Chrome → 설정 → 개인정보 및 보안 → 쿠키 및 사이트 데이터 관리

제 9 조 (개인정보 처리방침 변경 안내)
본 개인정보 처리방침은 법령 변경 및 서비스 정책에 따라 변경될 수 있습니다.
변경 사항은 최소 7일 전에 공지되며, 중요한 변경 사항은 회원에게 이메일 또는 서비스 내 공지를 통해 안내됩니다.
- 공고일: 2025-02-07
- 시행일: 2025-02-07
`;
